import { c as _c } from "react/compiler-runtime";
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// Persisted layout mode shared by the widget and the layouts.
export type ChatWidgetLayout = 'floating' | 'sidebar' | 'fullscreen';
const DEFAULT_LAYOUT: ChatWidgetLayout = 'floating';
const isLayout = (value: unknown): value is ChatWidgetLayout => value === 'floating' || value === 'sidebar' || value === 'fullscreen';
type ChatWidgetLayoutState = {
  mode: ChatWidgetLayout;
  setMode: (next: ChatWidgetLayout) => void;
  restoreMode: ChatWidgetLayout | null;
  setRestoreMode: (next: ChatWidgetLayout | null) => void;
};
const useStore = create<ChatWidgetLayoutState>()(persist(set => ({
  mode: DEFAULT_LAYOUT,
  setMode: next => set({
    mode: next
  }),
  restoreMode: null,
  setRestoreMode: next => set({
    restoreMode: next
  })
}), {
  name: 'percy.chat-widget-layout',
  partialize: state => ({
    mode: state.mode
  }),
  // Coerce an unknown persisted value back to the default rather than trusting it.
  merge: (persisted, current) => {
    const mode = isLayout((persisted as Partial<ChatWidgetLayoutState>)?.mode) ? (persisted as ChatWidgetLayoutState).mode : DEFAULT_LAYOUT;
    return {
      ...current,
      mode
    };
  }
}));
const useChatWidgetLayout = () => {
  const $ = _c(7);
  const {
    mode,
    setMode,
    restoreMode,
    setRestoreMode
  } = useStore();
  const t0 = mode === "sidebar";
  const t1 = mode === "fullscreen";
  let t2;
  if ($[0] !== mode || $[1] !== restoreMode || $[2] !== setMode || $[3] !== setRestoreMode || $[4] !== t0 || $[5] !== t1) {
    t2 = {
      mode,
      setMode,
      restoreMode,
      setRestoreMode,
      isSidebar: t0,
      isFullscreen: t1
    };
    $[0] = mode;
    $[1] = restoreMode;
    $[2] = setMode;
    $[3] = setRestoreMode;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export default useChatWidgetLayout;